import { render } from "./EditInterviewAttachment.vue?vue&type=template&id=5646de72"
import script from "./EditInterviewAttachment.vue?vue&type=script&lang=js"
export * from "./EditInterviewAttachment.vue?vue&type=script&lang=js"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__